import { Suspense } from 'react';
import type { ResolvedNavUtilityElement } from '@/lib/plugin-registry';

/**
 * Plugin utility icons (Chief's visor) for the takeover aside's pinned
 * footer. Takeover surfaces hide the app sidebar and with it the nav's
 * utility row, but the panels those icons open (`globalUiElements`) stay
 * mounted — so their doors must stay reachable too. `ml-auto` pins the
 * cluster to the right of whatever footer row hosts it
 * ({@link TakeoverFeedbackFooter}).
 *
 * The elements are lazy plugin components, so the cluster's chrome renders
 * inside the Suspense boundary — otherwise the footer would reserve space
 * for an empty cluster while the chunk loads.
 */
export function TakeoverUtilityRowView({
  elements,
}: {
  elements: readonly ResolvedNavUtilityElement[];
}) {
  if (elements.length === 0) return null;
  return (
    <Suspense fallback={null}>
      <div
        data-testid="takeover-utility-row"
        className="ml-auto flex min-h-10 shrink-0 items-center gap-1 px-2"
      >
        {elements.map(({ id, pluginName, component: Element }) => (
          <Element key={`${pluginName}:${id}`} compact />
        ))}
      </div>
    </Suspense>
  );
}
